import React, { useState } from "react"
import type { MyPlayerProps, PlayerDepositLimitProps, PlayerReferralProps, PlayerWithdrawLimitProps, PromoProps } from '../../types';
import { Toggle } from '../../Components';
import { WalletHelpers } from '../api';
import { Button, Text, View } from "../../Components/Themed";
import { useColors } from "../../constants/useColors";
import { FlatList } from "react-native";

type BEWalletProps = {
    player:MyPlayerProps,
    deposit_limit:PlayerDepositLimitProps,
    withdraw_limit:PlayerWithdrawLimitProps,
    my_referral: {
        player_referral?:PlayerReferralProps,
        promo?:PromoProps
    }
    onPremium?:() => void,
    onClose:() => void
}

const sections = ['header', 'toggle', 'deposit','withdraw','referral']
const WalletSettings = ({ player, my_referral, deposit_limit, withdraw_limit, onClose }:BEWalletProps) => {
    const [ active_tab, setActiveTab ] = useState('deposit');
    const Colors = useColors();
    //const promo = useSelector((state:RootState) => state.wallet.promo, (left, right) => left?.promo_id == right?.promo_id);
    //const player_referral = useSelector((state:RootState) => state.wallet.player_referral, (left, right) => left?.last_update_datetime == right?.last_update_datetime);

    const { player_referral, promo } = my_referral
    //const tabs = ['referral','deposit','withdraw']
    console.log(active_tab)
    console.log(deposit_limit)
    const renderSections = (data:{item:string, index:number}) => {
        switch(data.item){
            case 'header':
                return (
                    <View type='header' style={{ flexDirection:'row', alignItems:'center', padding:15 }}>
                        <View transparent style={{flex:1}}>
                            <Text size={20} theme='h1'>MY WALLET SETTINGS / LIMITS</Text>
                            <Text style={{ marginTop:5}} theme='description'>Below are your overall wallet settings & configurations. These are set based on account type and past transaction history</Text>
                        </View>
                    </View>
                )
            case 'toggle':
                return (
                    <View style={{ padding:10 }}>
                        <Toggle
                            options={[
                                {key: 'deposit', label:'Deposit' },
                                {key: 'withdraw', label:'Withdraw' },
                                {key: 'referral', label:'Referral' }
                            ]}
                            selected_option={active_tab}
                            onSelectOption={(option) => setActiveTab(option)}
                        />
                    </View>
                )
            case 'deposit':
                if(active_tab != 'deposit'){ return <></> }
                if(!deposit_limit){ return <></> }
                return (
                    <View nativeID="deposit_limit">
                        <View type='header' style={{ flexDirection:'row', alignItems:'center', padding:15 }}>
                            <View transparent style={{flex:1}}>
                                <Text theme='h1'>DEPOSIT SETTINGS</Text>
                                <Text style={{ marginTop:3}} theme='description'>Below are your current deposit limits.  These may change based on historical transaction results.</Text>
                            </View>
                        </View>
                        <View type='body' style={{ padding:10 }}>
                            <View type='row' style={{ flexDirection:'row', alignItems:'flex-start', padding:5, borderBottomWidth:1, borderColor:Colors.borders.light }}>
                                <View style={{ flex:1 }}>
                                    <Text theme="h2">ACH Daily Limit</Text>
                                    <Text style={{ marginTop:5 }} theme="description">The maximum deposit amount allowed per day from an ACH account</Text>
                                </View>
                                <View>
                                    <Text theme="h2">${deposit_limit.ach_daily_limit}</Text>
                                </View>
                            </View>
                            <View style={{ marginTop:10, flexDirection:'row', alignItems:'flex-start', padding:5, borderBottomWidth:1, borderColor:Colors.borders.light }}>
                                <View style={{ flex:1 }}>
                                    <Text theme="h2">Card / Paypal Daily Limit</Text>
                                    <Text style={{ marginTop:5 }} theme="description">The maximum deposit amount allowed per day from a card account</Text>
                                </View>
                                <View>
                                    <Text theme="h2">${deposit_limit.card_daily_limit}</Text>
                                </View>
                            </View>
                        <View style={{ flexDirection:'row', alignItems:'flex-start', marginTop:10, padding:5, borderBottomWidth:1, borderColor:Colors.borders.light }}>
                            <View style={{ flex:1 }}>
                                <Text theme="h2">Instant Deposit Limit</Text>
                                <Text style={{ marginTop:5 }} theme="description">The total amount of unsettled deposits that will be instantly added to your wallet.  Any deposit over this amount will be held until it settles.</Text>
                            </View>
                            <View>
                                <Text theme="h2">${deposit_limit.instant_limit}</Text>
                            </View>
                        </View>
                        <View style={{ marginTop:10, flexDirection:'row', alignItems:'flex-start', padding:5, borderBottomWidth:1, borderColor:Colors.borders.light }}>
                            <View style={{ flex:1 }}>
                                <Text theme='h2'>Hold Days</Text>
                                <Text style={{ marginTop:5 }} theme="description">The number of days a deposit transaction will be held (not settled) before it can be withdrawn</Text>
                            </View>
                            <View>
                                <Text theme="h2">{deposit_limit.hold_days}</Text>
                            </View>
                        </View>
                        <View style={{ flexDirection:'row', alignItems:'flex-start', marginTop:10, padding:5, borderBottomWidth:1, borderColor:Colors.borders.light }}>
                            <View style={{ flex:1 }}>
                                <Text theme="h2">Instant Deposit Available</Text>
                                <Text style={{ marginTop:5 }} theme="description">Your instant deposit limit minus your unsettled deposits</Text>
                            </View>
                            <View>
                                <Text size={14} color={deposit_limit.instant_available > 0 ? Colors.text.success : Colors.text.error} weight="bold">${deposit_limit.instant_available.toFixed(2)}</Text>
                            </View>
                        </View>
                        </View>
                    </View>
                )
            case 'withdraw':
                if(active_tab != 'withdraw' || !withdraw_limit){ return <></> }
                return (
                    <View nativeID="withdraw_settings">
                        <View type='header' style={{ flexDirection:'row', alignItems:'center', padding:15 }}>
                            <View transparent style={{flex:1}}>
                                <Text theme='h1'>WITHDRAW SETTINGS</Text>
                                <Text style={{ marginTop:3}} theme='description'>Below are your current withdraw settings and limits.  These may change based on historical transaction results.</Text>
                            </View>
                        </View>
                        <View type='body' style={{ padding:10 }}>
                        <View style={{ flexDirection:'row', alignItems:'flex-start', padding:5, borderBottomWidth:1, borderColor:Colors.borders.light }}>
                            <View style={{ flex:1 }}>
                                <Text theme="h2">Weekly Withdraw Transaction Limit</Text>
                                <Text style={{ marginTop:5 }} theme="description">The number of withdraws allowed per rolling week.</Text>
                            </View>
                            <View>
                                <Text theme="h2">{withdraw_limit.withdraws_per_week}</Text>
                            </View>
                        </View>
                        {withdraw_limit?.week_withdraw_count ?
                        <View style={{ marginTop:10, flexDirection:'row', alignItems:'flex-start', padding:5, borderBottomWidth:1, borderColor:Colors.borders.light }}>
                            <View style={{ flex:1 }}>
                                <Text theme="h2">Withdraws Remaining</Text>
                                <Text style={{ marginTop:5 }} theme="description">Withdraw transaction limit minus the number of withdraws already processed in the last 7 days</Text>
                            </View>
                            <View>
                                <Text theme="h2">{withdraw_limit.withdraws_per_week - withdraw_limit.week_withdraw_count}</Text>
                            </View>
                        </View>
                        :<></>}
                        <View style={{ marginTop:10, flexDirection:'row', alignItems:'flex-start', padding:5, borderBottomWidth:1, borderColor:Colors.borders.light }}>
                            <View style={{ flex:1 }}>
                                <Text theme="h2">ACH Withdraw Daily Limit</Text>
                                <Text style={{ marginTop:5 }} theme="description">Maximum amount of withdraws that can be made per rolling 24 hours to an ACH account.</Text>
                            </View>
                            <View>
                                <Text theme="h2">{withdraw_limit.ach_daily_limit}</Text>
                            </View>
                        </View>
                        <View style={{ marginTop:10, flexDirection:'row', alignItems:'flex-start', padding:5, borderBottomWidth:1, borderColor:Colors.borders.light }}>
                            <View style={{ flex:1 }}>
                                <Text theme="h2">Card Withdraw Daily Limit</Text>
                                <Text style={{ marginTop:5 }} theme="description">Maximum amount of withdraws that can be made per rolling 24 hours to a card account.</Text>
                            </View>
                            <View>
                                <Text theme="h2">{withdraw_limit.card_daily_limit}</Text>
                            </View>
                        </View>
                    </View>
                    </View>
                )
            case 'referral':
                if(active_tab != 'referral' || !player_referral || !promo){ return <></> }
                return (
                    <View nativeID="referral_settings">
                        <View type='header' style={{ flexDirection:'row', alignItems:'center', padding:15 }}>
                            <View transparent style={{flex:1}}>
                                <Text theme='h1'>REFERRAL SETTINGS</Text>
                                <Text style={{ marginTop:3}} theme='description'>Below are your current referral settings. Share your code with others to earn cash from referrals.</Text>
                            </View>
                        </View>
                        <View style={{ padding:10 }}>
                            <View style={{ flexDirection:'row', alignItems:'flex-start', padding:5, borderBottomWidth:1, borderColor:Colors.borders.light }}>
                                <View style={{ flex:1 }}>
                                    <Text theme="h2">My Referral Code</Text>
                                    <Text style={{ marginTop:5 }} theme="description">{WalletHelpers.getReferralDescription(promo)}</Text>
                                </View>
                                <View>
                                    <Text theme="h2">{player_referral.referral_code}</Text>
                                </View>
                            </View>
                        </View>
                    </View>
                )
            default: return <></>
        }
    }

    if(!player){ return <></> }
    return (
        <View style={{ flex:1 }}>
            <View style={{ flex:1 }}>
                <FlatList
                    data={sections}
                    key={`setting_sections`}
                    renderItem={renderSections}
                    keyExtractor={(item) => item}
                />
            </View>
            <View type='footer' style={{ flexDirection:'row', alignItems:'center', padding:20 }}>
                <Button
                    title='BACK'
                    type='close'
                    style={{ flex:1 }}
                    onPress={() => onClose()}
                />
            </View>
        </View>
    )
}

export default WalletSettings

